import api from './api';

const bancoService = {
    listarConfiguracoes: async () => {
        try {
            const response = await api.get('/enderecoBanco/listar');
            return response
        } catch (error) {
            console.error("Erro ao listar configurações:", error);
            throw error;
        }
    },

    salvarConfiguracao: async (dados) => {
        try {
            const response = await api.post('/enderecoBanco', dados);
            return response;
        } catch (error) {
            console.error("Erro ao salvar configuração:", error);
            throw error;
        }
    },

};

export default bancoService;